module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    style: (_vm.containerStyle),
    on: {
      "!mousedown": function($event) {
        return _vm.mousedownShelf.apply(null, arguments)
      },
      "mousemove": _vm.mousemove,
      "mouseup": function($event) {
        _vm.mousePositionBaked = null
      }
    }
  }, [(this.screenshot) ? _c('div', {
    staticClass: "saving"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "change-view"
  }, [_vm._v("\n        Вид:\n        "), _vm._l((_vm.cameraViews), function(view) {
    return _c('div', {
      staticClass: "view",
      class: {
        active: (view.id === _vm.currentCameraView)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentCameraView = view.id
        }
      }
    }, [_vm._v(_vm._s(view.title) + "\n        ")])
  }), _vm._v("\n\n        Zoom:\n        "), _vm._l((_vm.cameraZooms), function(zoom) {
    return _c('div', {
      staticClass: "view",
      class: {
        active: (zoom.value === _vm.currentCameraZoom)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.previousCameraZoom = _vm.currentCameraZoom;
          _vm.currentCameraZoom = zoom.value
        }
      }
    }, [_vm._v(_vm._s(zoom.title) + "\n        ")])
  }), _vm._v("\n\n        Верхняя полка:\n        "), _c('div', {
    staticClass: "view",
    class: {
      active: _vm.topSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topSideIsVisible = true
      }
    }
  }, [_vm._v("Вкл")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    class: {
      active: !_vm.topSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topSideIsVisible = false
      }
    }
  }, [_vm._v("Выкл")]), _vm._v("\n\n        Нижняя полка:\n        "), _c('div', {
    staticClass: "view",
    class: {
      active: _vm.bottomSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bottomSideIsVisible = true
      }
    }
  }, [_vm._v("Вкл\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    class: {
      active: !_vm.bottomSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bottomSideIsVisible = false
      }
    }
  }, [_vm._v("Выкл\n        ")]), _vm._v(" "), _c('br'), _vm._v("\n\n        Растащить:\n        "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по ширине"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillWidth(false, false)
      }
    }
  }, [_vm._v("⇄")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по ширине и выравнять по линиии первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillWidth(true, false)
      }
    }
  }, [_c('u', [_vm._v("⇄")])]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по ширине и выравнять по линиии первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillWidth(true, true)
      }
    }
  }, [_vm._v("|"), _c('u', [_vm._v("⇄")])]), _vm._v("\n\n         \n\n        "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по высоте"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillHeight.apply(null, arguments)
      }
    }
  }, [_vm._v("⇵")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по высоте и выравнять по линии первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillHeight(true, false)
      }
    }
  }, [_vm._v("|⇵\n        ")]), _vm._v("\n\n         \n\n        "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить в глубину"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillDepth.apply(null, arguments)
      }
    }
  }, [_vm._v("⤪")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить в глубину и выравнять по левому краю первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillDepth(true, true)
      }
    }
  }, [_vm._v("|⤪\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Убрать промежутки между пачками в ширине"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stackWidth.apply(null, arguments)
      }
    }
  }, [_vm._v("←\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Убрать промежутки между пачками по высоте"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stackHeight.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            ↓\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Убрать промежутки между пачками по глубине"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stackDepth.apply(null, arguments)
      }
    }
  }, [_vm._v("↗\n        ")])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shelf",
    style: (_vm.shelfStyle),
    attrs: {
      "id": "shelf",
      "title": ""
    },
    on: {
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseleave
    }
  }, [_c('svg', {
    staticClass: "extra-background",
    style: (_vm.bottomSide),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "id": "backgroundimage",
      "name": "backgroundimage",
      "viewBox": _vm.viewbox
    }
  }, [_c('g', {
    attrs: {
      "fill": "none"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "stroke": "#F79700",
      "stroke-width": "2",
      "points": _vm.shelfContour
    }
  })])]), _vm._v(" "), (_vm.bottomSideIsVisible) ? _c('div', {
    staticClass: "side bottom",
    style: (_vm.bottomSide)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "side left",
    style: (_vm.leftSide)
  }), _vm._v(" "), _c('div', {
    staticClass: "side right",
    style: (_vm.rightSide)
  }), _vm._v(" "), (_vm.topSideIsVisible) ? _c('div', {
    staticClass: "side top",
    style: (_vm.topSide)
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.packs), function(pack, id) {
    return _c('pack', {
      key: id,
      attrs: {
        "initWidth": pack.width,
        "initHeight": pack.initHeight,
        "initDepth": pack.initDepth,
        "initFrontImg": pack.initFrontImg,
        "initBackImg": pack.initBackImg,
        "initTopImg": pack.initTopImg,
        "initRightImg": pack.initRightImg,
        "initLeftImg": pack.initLeftImg,
        "initBottomImg": pack.initBottomImg,
        "dominantColor": pack.dominantColor,
        "isMirrored": pack.isMirrored,
        "initPos": pack.pos,
        "isDraggable": true,
        "id": id,
        "x": pack.x,
        "y": pack.y,
        "z": pack.z,
        "zoom": _vm.currentCameraZoom,
        "zIndex": pack.zIndex,
        "selected": pack.selected,
        "screenshot": _vm.screenshot
      },
      on: {
        "click": function($event) {
          return _vm.click($event)
        },
        "moveToSide": function($event) {
          return _vm.moveToSide($event)
        },
        "select": function($event) {
          return _vm.select($event)
        },
        "mousedown": _vm.mousedownPack,
        "removePack": function($event) {
          return _vm.removePack($event)
        },
        "sizeCalcutated": _vm.packSizeCalculated,
        "rotate": function($event) {
          return _vm.rotate($event)
        }
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaa3e200","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shelf/ShelfEditor.vue
// module id = 257
// module chunks = 1